<template>
  <CheckoutStep>
    <BouyguesError
      v-if="hasError"
      @continue-shopping="emit('exit-to-continue-shopping')"
      @try-again="emit('go-to-sign-up')"
    />
  </CheckoutStep>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { onUnmounted } from 'vue'

import type { HttpApiError } from '@backmarket/http-api'
import CheckoutStep from '@backmarket/nuxt-layer-checkout/components/CheckoutStep/CheckoutStep.vue'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { clearNuxtState, useState } from 'nuxt/app'

import BouyguesError from '../../components/BouyguesError/BouyguesError.vue'
import { useBouyguesAuthorize } from '../BouyguesSignUp/composables/useBouyguesAuthorize'

const route = useRoute()

const props = defineProps<{
  authRouteName: string
}>()

const emit = defineEmits<{
  'exit-to-continue-shopping': []
  'go-to-sign-up': []
  'go-to-phoneline-setup': [accessToken: string]
}>()

const { redirectUri } = useBouyguesAuthorize(props.authRouteName)
const logger = useLogger()
const $httpFetch = useHttpFetch()

const hasError = useState('bouygues-authentication-error')

if (!hasError.value) {
  const authorizationCode = route.query?.code

  // if there's no code on the url query params
  if (!authorizationCode || typeof authorizationCode !== 'string') {
    hasError.value = true
    logger.error('No Bouygues authentication code provided in url', {
      owners: ['bot-squad-b2cservices-front'],
    })
  } else {
    // Get access token
    try {
      const { accessToken } = await $httpFetch(
        '/mobile-plan/api/v1/auth/bouygues-token',
        {
          method: 'POST',
          body: { authorizationCode, redirectUri },
        },
      )

      emit('go-to-phoneline-setup', accessToken)
    } catch (err) {
      const error = err as HttpApiError
      hasError.value = true
      logger.error(error.message, {
        error,
        owners: ['bot-squad-b2cservices-front'],
      })
    }
  }
}

onUnmounted(() => clearNuxtState('bouygues-authentication-error'))
</script>
